import { ShortcutGroup, ShortcutGroupToShortcuts, ShortcutState, ShortcutUpdateModelv1, ShortcutsFilterv1 } from "modules/shortcuts/models";
import { ApiRequest } from "./network/ApiRequest";
import { SparrowApi } from "./network/adapters/SparrowApi";

export class ShortcutsApi {
    constructor(private _sparrowApi: SparrowApi) {}

    public getShortcutsFormat = (filters: ShortcutsFilterv1): ApiRequest<ShortcutGroupToShortcuts[]> => {
        const body = {
            searchText: filters.searchText,
            audiences: filters.audiences,
            enabled: filters.state.length === 1 ? filters.state.includes(ShortcutState.ENABLED) : undefined
        };

        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post("/{tenant}/adminapi/v1/shortcuts/format/filter", body)
        );
    }

    public updateShortcutsFormat = (newFormat: ShortcutGroupToShortcuts[]) => {
        const body = JSON.stringify(newFormat);

        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(
                    `/{tenant}/adminapi/v1/shortcuts/format`, 
                    body, 
                    { headers: { "content-type": "application/json" } })
                );
    }

    public getShortcut = (shortcutId: string) => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(`/{tenant}/adminapi/v1/shortcuts?id=${shortcutId}`)
        );
    }

    public updateShortcut = (shortcutId: string, shortcutUpdateModel: ShortcutUpdateModelv1) => {
        const body = {
            audiences: shortcutUpdateModel.audiences,
            openInNewWindow: shortcutUpdateModel.openInNewWindow,
            isEnabled: shortcutUpdateModel.isEnabled,
            url: shortcutUpdateModel.url,
            groupId: shortcutUpdateModel.groupId,
            name: shortcutUpdateModel.name
        };

        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(`/{tenant}/adminapi/v1/shortcuts?id=${shortcutId}`, body)
        );
    }

    public createNewShortcut = (shortcutUpdateModel: ShortcutUpdateModelv1) => {
        const body = {
            audiences: shortcutUpdateModel.audiences,
            openInNewWindow: shortcutUpdateModel.openInNewWindow,
            isEnabled: shortcutUpdateModel.isEnabled,
            url: shortcutUpdateModel.url,
            groupId: shortcutUpdateModel.groupId,
            name: shortcutUpdateModel.name
        };

        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(`/{tenant}/adminapi/v1/shortcuts/new`, body)
        );
    }

    public bulkUpdateShortcuts = (shortcutIds: string[], setIsEnabled?: boolean, groupIdToMoveTo: string = "") => {
        const body = JSON.stringify(shortcutIds);

        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(
                    `/{tenant}/adminapi/v1/shortcuts/bulk?groupIdToMoveTo=${groupIdToMoveTo}${setIsEnabled !== undefined ? '&setIsEnabled=' + setIsEnabled : ''}`,
                    body,
                    { headers: { "content-type": "application/json" } }
                )
        );
    }

    public bulkDeleteShortcuts = (shortcutIds: string[]) => {
        const body = JSON.stringify(shortcutIds);

        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(
                    `/{tenant}/adminapi/v1/shortcuts/bulk/delete`, 
                    body,
                    { headers: { "content-type": "application/json" } }
                )
        );
    }

    public getShortcutGroups = (searchText: string = ""): ApiRequest<ShortcutGroup[]> => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .get(`/{tenant}/adminapi/v1/shortcuts/groups?searchText=${searchText}`)
        );
    }

    public bulkDeleteShortcutGroups = (shortcutGroupids: string[]) => {
        const body = JSON.stringify(shortcutGroupids);

        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(
                    `/{tenant}/adminapi/v1/shortcuts/groups/delete`, 
                    body,
                    { headers: { "content-type": "application/json" } }
                )
        );
    }

    public updateShortcutGroupName = (shortcutGroupId: string, newName: string) => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(`/{tenant}/adminapi/v1/shortcuts/groups?id=${shortcutGroupId}&name=${newName}`)
        );
    }

    public createNewShortcutGroup = (name: string) => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .post(`/{tenant}/adminapi/v1/shortcuts/groups/new?name=${name}`)
        );
    }

    public getClientShortcutsList = (): ApiRequest<ShortcutGroupToShortcuts[]> => {
        return new ApiRequest(
            this._sparrowApi.TenantRequest()
                .get(`/{tenant}/api/v1/shortcuts`)
        );
    }
}